import { getRuntimeConfig } from './runtimeConfig.ts';

const BACKEND_PATH_PATTERN = /^\/(?:api(?:\/|\?|#|$)|health(?:\?|#|$)|metrics(?:\?|#|$))/;

function trimTrailingSlash(value: string): string {
  return value.replace(/\/+$/, '');
}

function getWindowOrigin(): string | null {
  if (typeof window === 'undefined' || !window.location?.origin) {
    return null;
  }
  return window.location.origin;
}

function isBackendPath(pathname: string): boolean {
  return BACKEND_PATH_PATTERN.test(pathname);
}

export function normalizeApiBaseUrl(value: string | undefined): string {
  return trimTrailingSlash((value ?? '').trim());
}

export function getApiBaseUrl(): string {
  return normalizeApiBaseUrl(getRuntimeConfig().apiBaseUrl);
}

export function resolveApiUrl(
  input: string | URL,
  apiBaseUrl: string,
  currentOrigin: string | null = getWindowOrigin()
): string {
  const raw = String(input);
  const base = normalizeApiBaseUrl(apiBaseUrl);

  if (!base) {
    return raw;
  }

  if (raw.startsWith('/')) {
    return isBackendPath(raw) ? `${base}${raw}` : raw;
  }

  try {
    const url = new URL(raw);
    if (
      currentOrigin &&
      url.origin === currentOrigin &&
      isBackendPath(url.pathname)
    ) {
      return `${base}${url.pathname}${url.search}${url.hash}`;
    }
  } catch {
    return raw;
  }

  return raw;
}

export function apiUrl(input: string | URL): string {
  return resolveApiUrl(input, getApiBaseUrl());
}
